export default {
  getters: {
    storesSortList: (state, getters, rootState) => {
      let list = [];

      if (rootState.stores.list.length > 1) {
        list = ["distance", "alphabetic"];
        if (rootState.stores.sortBy == "customize") list.push(rootState.stores.sortBy);
      }

      return list;
    },

    storeCompanyCode: (state, getters, rootState) => {
      if (rootState.store != null) return rootState.store.companyCode;
      else return null;
    },

    storeInfo: (state, getters, rootState) => {
      if (rootState.store != null) return rootState.store.info;
      else return null;
    },

    storeName: (state, getters, rootState) => {
      let name = "";
      if (getters.storeInfo != null) name = getters.storeInfo.companyName;
      if (
        rootState.languageSelected != null &&
        rootState.languageSelected.storeName != null &&
        rootState.languageSelected.storeName != ""
      )
        name = rootState.languageSelected.storeName;

      return name;
    },

    storeTimeZoneAbbrev: (state, getters) => {
      return getters.storeInfo != null && getters.storeInfo.timeZoneAbbrev != null
        ? getters.storeInfo.timeZoneAbbrev
        : "";
    },

    storeTimeZone: (state, getters) => {
      let timeZone = "Canada/Eastern";
      if (getters.storeInfo != null && getters.storeInfo.timeZone != null) {
        timeZone = getters.storeInfo.timeZone;
      }

      return timeZone;
    },

    storeTimeZoneMatched: (state, getters) => {
      if (getters.storeInfo != null && getters.storeInfo.timeZoneUtcOffsetMin != null) {
        let now = new Date();
        let deviceUtcOffsetMin = -now.getTimezoneOffset();
        return deviceUtcOffsetMin == getters.storeInfo.timeZoneUtcOffsetMin;
      } else return true;
    },

    storeTel: (state, getters) => {
      let tel = "";
      if (getters.storeInfo.address != null) {
        let addr = getters.storeInfo.address;
        if (addr.tel != null && addr.tel != "") {
          tel = addr.tel;
        }
      }
      return tel;
    },

    storeAddress: (state, getters) => {
      let address = {};
      if (getters.storeInfo.address != null) {
        address = getters.storeInfo.address;
      }
      return address;
    },

    storeOrderTypes: (state, getters, rootState) => {
      if (rootState.store != null) return rootState.store.orderType;
      else return null;
    },

    storeOrderType: (state, getters, rootState) => orderType => {
      let om;
      if (getters.storeOrderTypes != null) {
        if (orderType == rootState.OT_DINEIN) {
          om = getters.storeOrderTypes.dinein;
        } else if (orderType == rootState.OT_TAKEOUT) {
          om = getters.storeOrderTypes.takeout;
        } else if (orderType == rootState.OT_DELIVERY) {
          om = getters.storeOrderTypes.delivery;
        }
      }
      return om;
    },

    storeCovidContactFormUrl: (state, getters, rootState) => {
      if (
        rootState.store != null &&
        rootState.store.config != null &&
        rootState.store.config.covidContactFormUrl != null
      )
        return rootState.store.config.covidContactFormUrl;
      else return "";
    },

    notAskDineInGuestPhone: (state, getters, rootState) => {
      if (
        rootState.store != null &&
        rootState.store.config != null &&
        rootState.store.config.notAskDineInGuestPhone != null
      )
        return rootState.store.config.notAskDineInGuestPhone;
      else return false;
    },

    addShortcutBarEnabled: (state, getters, rootState) => {
      if (rootState.stores.list.length > 0) {
        return rootState.stores.addShortcutBarEnabled;
      } else if (
        rootState.store != null &&
        rootState.store.config != null &&
        rootState.store.config.addShortcutBarEnabled != null
      )
        return rootState.store.config.addShortcutBarEnabled;
      else return false;
    },

    notCheckServerOnline: (state, getters, rootState) => {
      if (
        rootState.store != null &&
        rootState.store.config != null &&
        rootState.store.config.notCheckServerOnline != null
      )
        return rootState.store.config.notCheckServerOnline;
      else return false;
    },

    storeMenuMode: (state, getters, rootState) => {
      return rootState.order.orderType == rootState.OT_DINEIN && getters.storeDineinMenuMode;
    },

    storeDineinVisible: (state, getters) => {
      if (
        getters.storeOrderTypes != null &&
        getters.storeOrderTypes.dinein != null &&
        getters.storeOrderTypes.dinein.hide != null
      ) {
        return !getters.storeOrderTypes.dinein.hide;
      } else return true;
    },

    storeDineinMenuMode: (state, getters) => {
      if (
        getters.storeOrderTypes != null &&
        getters.storeOrderTypes.dinein != null &&
        getters.storeOrderTypes.dinein.menuMode != null
      ) {
        return getters.storeOrderTypes.dinein.menuMode;
      } else return false;
    },

    storeTakeoutVisible: (state, getters) => {
      if (
        getters.storeOrderTypes != null &&
        getters.storeOrderTypes.takeout != null &&
        getters.storeOrderTypes.takeout.hide != null
      ) {
        return !getters.storeOrderTypes.takeout.hide;
      } else return true;
    },

    storeDeliveryVisible: (state, getters) => {
      if (
        getters.storeOrderTypes != null &&
        getters.storeOrderTypes.delivery != null &&
        getters.storeOrderTypes.delivery.hide != null
      ) {
        return !getters.storeOrderTypes.delivery.hide;
      } else return true;
    },

    storeWaitlistVisible: (state, getters) => {
      return getters.storeWaitlistEnabled;
    },

    storeReserveVisible: (state, getters) => {
      return getters.storeReserveEnabled;
    },

    storeDineinAskTableName: (state, getters) => {
      if (
        getters.storeOrderTypes != null &&
        getters.storeOrderTypes.dinein != null &&
        getters.storeOrderTypes.dinein.askTableName != null
      ) {
        return getters.storeOrderTypes.dinein.askTableName;
      } else return false;
    },

    storeWaitlistEnabled: (state, getters, rootState) => {
      return (
        rootState.memberEnabled &&
        rootState.store != null &&
        rootState.store.service != null &&
        rootState.store.service.waitlistEnabled
      );
    },

    storeReserveEnabled: (state, getters, rootState) => {
      return (
        rootState.memberEnabled &&
        rootState.store != null &&
        rootState.store.service != null &&
        rootState.store.service.reserveEnabled
      );
    },

    deliveryCharge: (state, getters) => distance => {
      let charge = 0;
      let ruleMax;
      if (
        getters.storeOrderTypes != null &&
        getters.storeOrderTypes.delivery != null &&
        getters.storeOrderTypes.delivery.chargeRules != null &&
        Array.isArray(getters.storeOrderTypes.delivery.chargeRules)
      ) {
        let chargeRules = getters.storeOrderTypes.delivery.chargeRules;
        chargeRules.forEach(rule => {
          if (rule.from < distance && rule.to >= distance) charge = rule.charge;
          if (ruleMax == null || rule.to > ruleMax.to) ruleMax = rule;
        });

        if (ruleMax != null && distance > ruleMax.to) charge = ruleMax.charge;
      }
      return charge;
    },

    deliveryAgentAdjustment: (state, getters) => {
      let adjustment = { value: 0, byPercentage: false };
      if (getters.storeOrderTypes != null && getters.storeOrderTypes.delivery != null) {
        let otd = getters.storeOrderTypes.delivery;
        if (otd.agentAdjValue) adjustment.value = otd.agentAdjValue;
        if (otd.agentAdjByPercentage) adjustment.byPercentage = otd.agentAdjByPercentage;
      }
      return adjustment;
    },

    deliveryMaxDistance: (state, getters) => {
      return getters.storeOrderTypes.delivery.distance;
    },

    deliveryAdjustedCharge: (state, getters) => value => {
      let charge = value;
      let adjustment = getters.deliveryAgentAdjustment;

      if (adjustment.byPercentage) {
        charge = charge * (1 + adjustment.value / 100);
      } else {
        charge += adjustment.value;
      }
      if (charge < 0) charge = 0;

      return charge;
    },

    deliveryAgentChargeUsed: (state, getters) => {
      let used = false;
      if (getters.storeOrderTypes != null && getters.storeOrderTypes.delivery != null) {
        let otd = getters.storeOrderTypes.delivery;
        if (otd.agentChargeUsed) used = otd.agentChargeUsed;
      }
      return used;
    },

    itemStockEnabled: (state, getters) => {
      return (
        getters.storeInfo != null && getters.storeInfo.itemStockEnabled != null && getters.storeInfo.itemStockEnabled
      );
    },

    merchants: (state, getters, rootState) => {
      let n_merchants = null;
      if (rootState.store != null && rootState.store.checkout != null && rootState.store.checkout.merchants != null) {
        n_merchants = rootState.store.checkout.merchants;
      }

      return n_merchants;
    },

    stripeEnabled: (state, getters) => {
      let merchants = getters.merchants;
      return merchants != null && merchants.includes("stripe");
    },

    globalPaymentEnabled: (state, getters) => {
      let merchants = getters.merchants;
      return merchants != null && merchants.includes("globalPayment");
    },
  },
};
